import React from "react";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ShortBookingSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.circle}>
          <CheckCircleIcon style={{ fontSize: 60, color: "#fff" }} />
        </div>

        <h2 style={styles.title}>Booking Confirmed</h2>
        <p style={styles.subtitle}>
          Your short-stay reservation was successful!
        </p>

        <button
          style={styles.doneButton}
          onClick={() => navigate("/")}
        >
          Go Home
        </button>
      </div>
    </div>
  );
};

export default ShortBookingSuccess;

/* 💅 Vacant-themed styles */
const styles: { [key: string]: React.CSSProperties } = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Poppins, sans-serif",
    padding: "2rem",
  },
  card: {
    backgroundColor: "#111",
    borderRadius: 20,
    padding: "2.5rem 2rem",
    width: "95%",
    maxWidth: 420,
    textAlign: "center",
    boxShadow: "0 10px 40px rgba(0,0,0,0.7)",
    border: "1px solid rgba(191,155,48,0.4)",
    transition: "all 0.4s ease",
  },
  circle: {
    width: 90,
    height: 90,
    borderRadius: "50%",
    background: "linear-gradient(145deg, #bf9b30, #d4af37)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 1.5rem auto",
    boxShadow: "0 6px 16px rgba(191,155,48,0.4)",
  },
  title: {
    color: "#bf9b30",
    fontSize: "1.6rem",
    fontWeight: 700,
    marginBottom: "0.8rem",
  },
  subtitle: {
    color: "#ccc",
    fontSize: "0.95rem",
    marginBottom: "2rem",
  },
  doneButton: {
    background: "linear-gradient(135deg, #bf9b30, #d4af37)",
    color: "#111",
    border: "none",
    borderRadius: 30,
    padding: "12px 40px",
    fontSize: "1rem",
    fontWeight: 700,
    cursor: "pointer",
    transition: "all 0.25s ease",
    boxShadow: "0 6px 18px rgba(191,155,48,0.3)",
  },
};
